import { useState } from "react";

import { ResourceShareModal } from "@/components/pieces/roleplays/sharing/ResourceShareModal";
import { Button } from "@/components/ui/button";
import { SharingStatusIcon } from "@/components/ui/sharing/SharingStatusIcon";
import { ResourceType, ScenarioDocument } from "@/graphql";
import { FullScenario } from "@/types/roleplays";

export function ScenarioShare({ scenario }: { scenario: FullScenario }) {
  const [isOpen, setIsOpen] = useState(false);

  if (!scenario?.sharingStatus) {
    return null;
  }

  return (
    <>
      <Button
        intent="secondary"
        className="h-10"
        onClick={() => {
          setIsOpen(true);
        }}
      >
        <SharingStatusIcon
          sharingStatus={scenario.sharingStatus}
          showTooltip={false}
        />
        Share
      </Button>

      <ResourceShareModal
        resource={scenario}
        resourceType={ResourceType.Scenario}
        resourceName="Scenario"
        isOpen={isOpen}
        onClose={() => {
          setIsOpen(false);
        }}
        loading={false}
        refetchQuery={ScenarioDocument}
        refetchVariables={{ scenarioSlug: scenario.slug }}
        workspaceInfoMessage="Workspace admins can see some information about this scenario in analytics."
        canUpdatePermission={scenario.canUpdatePermission}
        owner={scenario.owner}
      />
    </>
  );
}
